import axios from 'axios'

function clone(obj) {
    return JSON.parse(JSON.stringify(obj))
}

const state = () => ({
    isOpenDialog: false,
    isEditableForm: false,
    formType: '',
    editingId: '',
    Name: '',
    Id: '',
    objectives: [],
    paths: {
        objectivesPath: '/api/servicios/tipoobjetivo/',
    }
})

const mutations = {
    isOpenDialog: (state, val) => {
        state.isOpenDialog = val;
    },
    isEditableForm: (state, val) => {
        state.isEditableForm = val;
    },
    formType: (state, val) => {
        state.formType = val;
    },
    editingId: (state, val) => {
        state.editingId = val;
    },
    Name: (state, val) => {
        state.Name = val
    },
    Id: (state, val) => {
        state.Id = val
    },
    objectives: (state, val) => {
        state.objectives = clone(val)
    },
}

const actions = {
    async getObjectives({ dispatch, getters, state, commit }) {
        try {
            let resp = await axios.get(getters.getEndpointFromPath(state.paths.objectivesPath))
            commit('objectives', resp.data)

            // dispatch('util/showStatusSnackBar', {
            //     statusType: 'success',
            //     message: 'Tipo de Objetivo Cargados Correctamente'
            // }, { root: true })
        }
        catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'No se pudo cargar el contenido de Tipo de Objetivo'
            }, { root: true })
        }
    },
    async delete({ state, dispatch, getters }, item) {
        try {
            await axios.delete(getters.getEndpointFromPath(state.paths.objectivesPath) + item.id)
            dispatch('getObjectives')
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Entrada borrada'
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'error',
                message: 'No se pudo eliminar la entrada'
            }, { root: true })
        }
    },
    async addOrigin({ state, getters, dispatch }) {
        let objective = {
            'nombre': state.Name,
        }

        try {
            await axios.post(getters.getEndpointFromPath(state.paths.objectivesPath), objective)
            dispatch('getObjectives')
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Origen Añadido Correctamente',
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Error al Añadir Origen',
            }, { root: true })
        }
    },
    async editOrigin({ state, getters, dispatch }) {
        let objective = {
            'nombre': state.Name,
        }

        try {
            await axios.put(getters.getEndpointFromPath(state.paths.objectivesPath) + state.editingId + '/', objective)
            dispatch('getObjectives')
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Origen Actualizado Correctamente',
            }, { root: true })
        } catch {
            dispatch('util/showStatusSnackBar', {
                statusType: 'success',
                message: 'Error al Actualizar el Origen',
            }, { root: true })
        }
    },
}

const getters = {
    getEndpointFromPath: (_state, _unused, rootState) => endpoint => (
        rootState.general.host + endpoint
    )
}

export default {
    namespaced: true,
    state,
    mutations,
    getters,
    actions
}